import config from "../../config";
const baseUrl = config.baseUrl;

export const MedicineDetailsUrls = {

 MEDICINE_DETAILS_ADD: baseUrl + "/medicineDiagnosis",
 MEDICINE_DETAILS_EDIT: baseUrl + "/medicineDiagnosis",
 MEDICINE_DETAILS_STATUS: baseUrl + "/medicineDiagnosis/changedStatus",
 MEDICINE_DETAILS_LIST: baseUrl + "/medicineDiagnosis",
 MEDICINE_DETAILS_DELETE: baseUrl + "/medicineDiagnosis",
 MEDICINE_DETAILS_GETBYID: baseUrl + "/medicineDiagnosis",
 MEDICINE_DETAILS_ROLLBACK: baseUrl + "/medicineDiagnosis/rollback",
 MEDICINE_DETAILS_DROPDOWN: baseUrl + "/medicineDiagnosis/dropdown", 
 MEDICINE_DETAILS_DELETE_HARD: baseUrl + "/medicineDiagnosis",
};